import { CSSProperties, Fragment } from 'react';
import Message from './Message';
import { useToastMessages } from './hooks';

const ToastRootStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: 10,
    pointerEvents: 'none',
};

function ToastRender(): JSX.Element {
    const messages = useToastMessages();
    return (
        <>
            {messages.length > 0 && (
                <div role="alert" style={ToastRootStyle}>
                    {messages.map(item => (
                        <Message key={item.id} {...item} />
                    ))}
                </div>
            )}
        </>
    );
}

function ToastView(props?: { children?: React.ReactNode }): JSX.Element {
    return (
        <Fragment key="Toaster">
            <ToastRender />
            {props?.children}
        </Fragment>
    );
}

export default ToastView;
